import React from 'react';

// Clean light backdrop: faint dotted texture + a soft brand wash in the corners.
export const SoftBackground = () => {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-background">
      <div className="absolute inset-0 bg-dots opacity-70" />
      <div className="absolute -left-40 -top-40 h-[28rem] w-[28rem] rounded-full bg-primary/5 blur-3xl" />
      <div className="absolute -bottom-40 -right-32 h-[26rem] w-[26rem] rounded-full bg-accent/5 blur-3xl" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-brand opacity-80" />
    </div>
  );
};
